var app = angular.module("nms.manageDevices", []);

app.config(["$translatePartialLoaderProvider", function($translatePartialLoader) {
    $translatePartialLoader.addPart("features/manage-devices");
}]);

app.run(["$translate",
    function($translate) {
        $translate.refresh();
    }
]);
